import { useState, lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { withTranslation } from "react-i18next";
import PrivateRoute from "./common/PrivateRoute";
import PublicRoute from "./common/PublicRoute";
import WaitDialog from "./components/WaitDialog";
import { isLogin } from "./common/token-check.js";
import Layout from "./components/Layout.jsx";

const Register = lazy(() => import("./pages/Register"));
const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const Index = lazy(() => import("./pages/Index"));
const Home = lazy(() => import("./pages/Home"));
const SendDataPage = lazy(() => import("./pages/SendData"));
const ProductsPage = lazy(() => import("./pages/Products"));
const Navbar = lazy(() => import("./components/Navbar"));

const App = ({ t }) => {
  const [loading] = useState(false);
  const loggedIn = isLogin();

  return (
    <Router>
      <Suspense fallback={null}>
        <Navbar />
      </Suspense>

      <Suspense fallback={<div />}>
        <Routes>
          <Route path="/home" element={<PrivateRoute component={Home} />} />
          <Route
            path="/send"
            element={<PrivateRoute component={SendDataPage} />}
          />
          <Route
            path="/products"
            element={<PrivateRoute component={ProductsPage} />}
          />

          <Route
            path="/*"
            element={
              <Layout>
                <Routes>
                  <Route
                    path="/"
                    element={<PublicRoute restricted component={Index} />}
                  />
                  <Route
                    path="/register"
                    element={<PublicRoute restricted component={Register} />}
                  />
                  <Route
                    path="/login"
                    element={<PublicRoute restricted component={Login} />}
                  />
                  <Route
                    path="/forgotPassword"
                    element={
                      <PublicRoute restricted component={ForgotPassword} />
                    }
                  />
                </Routes>
              </Layout>
            }
          />

          <Route
            path="*"
            element={<Navigate to={loggedIn ? "/home" : "/"} replace />}
          />
        </Routes>
      </Suspense>

      <WaitDialog loading={loading} lang={t} />
    </Router>
  );
};

export default withTranslation()(App);
